// SharpFlat.js

import React from 'react'
import './SharpFlat.css';
import YunHeader from '../Common/YunHeader/YunHeader';
import YunSection from '../Common/YunSection/YunSection';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Switch from '@material-ui/core/Switch';

import { 
    cppInstallAutoTunePlugin,
    cppUnInstallAutoTunePlugin,
    setWindowTitle,
    cppSetWindowIcon,
    cppAutoTunePluginPath,
    cppExploreFolder,
    cppCloseWindow,
    cppBroadcastWndMsg,
    cppInstallQQMusicAutoTunePlugin,
    cppUnInstallQQMusicAutoTunePlugin,
    cppQQMusicAutoTunePluginPath,
    cppInstallKwMusicPlugin,
    cppUnInstallKwMusicPlugin,
    cppKwMusicPluginPath,
    cppGetAppInfo,
    cppGetKugouAudioEffectStatus,
    cppSetKugouAudioEffectStatus,
} from '../../api/cpp'

import getProductInfo from '../../static/getProductInfo';

import {
    getSharpflatModel,
    setSharpflatModel,
    getKugouEffectTipDisable,
    setKugouEffectTipDisable,
} from '../App/local';
import { getPluginShowName } from '../App/tools';
import { compareVersions } from '../../utils/index';

const appInfo = cppGetAppInfo();
const isNewVersion396 = compareVersions(appInfo && appInfo.version, "3.9.6"); //为true表示3.9.6以上新版本 不包含3.9.6本身
class SharpFlat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pluginName: "升降调",
            addDia: false,
            removeDia: false,
            diaType: "kugou",
            diaText: "酷狗音乐播放器",
            sharpFlatState: {
                online: false,
                pluginAry: [],
            },
            sharpFlatModel: getSharpflatModel(),
            productInfo: {},
            // 酷狗内部效果是否启用
            kugouEffectEnable: false,
            // 酷狗效果提示框
            kugouEffectDiaShow: true,
            // 操作提示框
            kugouEffectHandleDia: false,
        };

        this.handleShowAddDia = this.handleShowAddDia.bind(this);
        this.handleShowRemoveDia = this.handleShowRemoveDia.bind(this);
        this.handleInstallPlugin = this.handleInstallPlugin.bind(this);
        this.handleUnInstallPlugin = this.handleUnInstallPlugin.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.clickToPluginDir = this.clickToPluginDir.bind(this);
        this.clickSetSharpFlatModel = this.clickSetSharpFlatModel.bind(this);
        this.initState = this.initState.bind(this);

        this.changeKugouEffectEnable = this.changeKugouEffectEnable.bind(this);
        this.changeKugouEffectDiaShow = this.changeKugouEffectDiaShow.bind(this);
        this.showKugouEffectHandleDia = this.showKugouEffectHandleDia.bind(this);
    }

    handleShowAddDia(type) {
        let text = "酷狗音乐播放器";
        if (type === "qq") {
            text = "QQ音乐播放器";
        } else if (type === "kuwo") {
            text = "酷我音乐播放器";
        }
        this.setState({
            addDia: true,
            diaType: type,
            diaText: text,
        })
    }
    handleShowRemoveDia(type) {
        let text = "酷狗音乐播放器";
        if (type === "qq") {
            text = "QQ音乐播放器";
        } else if (type === "kuwo") {
            text = "酷我音乐播放器";
        }
        this.setState({
            removeDia: true,
            diaType: type,
            diaText: text,
        })
    }
    // 安装插件
    handleInstallPlugin() {
        this.handleClose();
        if (this.state.diaType === "kugou") {
            cppInstallAutoTunePlugin(this.state.pluginName, false);
            cppInstallAutoTunePlugin("emFix", false)
        } else if (this.state.diaType === "qq") {
            cppInstallQQMusicAutoTunePlugin(this.state.pluginName);
        } else if (this.state.diaType === "kuwo") {
            cppInstallKwMusicPlugin(this.state.pluginName);
        }
    }
    // 卸载插件
    handleUnInstallPlugin() {
        this.handleClose();
        if (this.state.diaType === "kugou") {
            cppUnInstallAutoTunePlugin(this.state.pluginName);
        } else if (this.state.diaType === "qq") {
            cppUnInstallQQMusicAutoTunePlugin(this.state.pluginName);
        } else if (this.state.diaType === "kuwo") {
            cppUnInstallKwMusicPlugin(this.state.pluginName);
        }
    }
    // 打开插件目录
    clickToPluginDir(type) {
        let pluginFile = "";
        if (type === "kugou") {
            pluginFile = cppAutoTunePluginPath(this.state.pluginName);
        } else if (type === "qq") {
            pluginFile = cppQQMusicAutoTunePluginPath(this.state.pluginName);
        } else if (type === "kuwo") {
            pluginFile = cppKwMusicPluginPath(this.state.pluginName);
        }
        if (pluginFile) {
            const dir = pluginFile.split('\\').slice(0, -1).join('\\')
            cppExploreFolder(dir)
        }
    }
    // 关闭弹框
    handleClose() {
        this.setState({
            addDia: false,
            removeDia: false,
            kugouEffectHandleDia: false,
        })
    }
    // 点击设置升降调模式
    clickSetSharpFlatModel(model) {
        if (model === this.state.sharpFlatModel) {
            return false
        }
        if (!['reset', 'renew', 'lock'].includes(model)) {
            model = 'renew'
        }
        this.setState({
            sharpFlatModel: model,
        })
        setSharpflatModel(model);
        // 将当前状态通知到主页面
        cppBroadcastWndMsg('SharpFlatModel' + model);
    }

    // 初始化状态
    initState() {
        this.setState({
            sharpFlatModel: getSharpflatModel(),
        })
    }

    // 设置酷狗内部音效启用
    showKugouEffectHandleDia() {
        this.setState({
            kugouEffectHandleDia: true
        })
    }
    changeKugouEffectEnable() {
        this.handleClose();
        const enable = !this.state.kugouEffectEnable
        this.setState({
            kugouEffectEnable: enable,
        })
        cppSetKugouAudioEffectStatus(enable);
    }
    // 设置酷狗音效提示框
    changeKugouEffectDiaShow() {
        const enable = !this.state.kugouEffectDiaShow
        this.setState({
            kugouEffectDiaShow: enable,
        })
        setKugouEffectTipDisable(!enable);
    }
    

    componentDidMount() {
        setWindowTitle('伴奏升降调设置');
        getProductInfo().then(productInfo => {
            this.setState({
                productInfo: productInfo,
            })
            cppSetWindowIcon(productInfo.WindowIconFileName);
        })

        if (isNewVersion396) {
            this.setState({
                kugouEffectEnable: cppGetKugouAudioEffectStatus(),
                kugouEffectDiaShow: !getKugouEffectTipDisable(),
            })
        }

        // 广播信息 同步插件状态
        setTimeout(() => {
            cppBroadcastWndMsg('Init_Plugin_State');
        }, 1000);

        // 监听别的页面的通知消息
        try {
            window.onRecvBroadcastWndMsg = (msg) => {
                if (msg === 'Login_In') {
                    // 回到登录页面时，关闭此页面
                    cppCloseWindow()
                }
                // 重置状态
                if (msg === 'Reload_State') {
                    this.initState();
                }
                if (msg && /^sharpFlatPluginStateInfo/.test(msg)) {
                    const sharpFlatState = JSON.parse(msg.replace('sharpFlatPluginStateInfo', ''))
                    if (sharpFlatState && sharpFlatState.pluginAry && Array.isArray(sharpFlatState.pluginAry)) {
                        this.setState({
                            sharpFlatState: sharpFlatState
                        })
                    }
                }
            }
        } catch (error) {
        }
        // 监听插件状态
        try {
            window.onPluginStatChange = (name, online) => {
                if (typeof name === "string" && name.includes(this.state.pluginName)) {
                    const sharpFlatPluginAry = JSON.parse(JSON.stringify(this.state.sharpFlatState.pluginAry))
                    if (online) {
                        sharpFlatPluginAry.push(name)
                    } else {
                        const index = sharpFlatPluginAry.indexOf(name);
                        if (index !== -1) {
                            sharpFlatPluginAry.splice(index, 1);
                        }
                    }
                    this.setState({
                        sharpFlatState: {
                            pluginAry: sharpFlatPluginAry,
                            online: Boolean(sharpFlatPluginAry.length),
                        }
                    })
                }
            }
        } catch (error) {
        }
    }

    render() {
        const sharpFlatModel = this.state.sharpFlatModel
        const pluginAry = this.state.sharpFlatState.pluginAry
        const diaClassNameStr = isNewVersion396 ? "ShapFlatDia V396" : "ShapFlatDia"
        return (
            <div className="SharpFlat AppContainer">
                <YunHeader hideOnTop hideMin productInfo={this.state.productInfo} title="伴奏升降调"></YunHeader>
                {/* 升降调插件状态 */}
                <YunSection className="SettingBox" width="200" height="60">
                    <div className="Flex">
                        <div className="Label">升降调插件状态</div>
                        <p className="HoverColor MainColor">{pluginAry.length ? '已连接' : '未连接'}</p>
                    </div>
                    <div>
                        <p className="Text">{getPluginShowName(pluginAry[pluginAry.length - 1])}</p>
                    </div>
                </YunSection>
                {/* 酷狗内部音效 */}
                {
                    isNewVersion396 && (
                        <YunSection className="SettingBox" width="200" height="60">
                            <div className="Flex">
                                <div className="Label">酷狗内部音效</div>
                                <p className="HoverColor MainColor">{this.state.kugouEffectEnable ? '已开启' : '未开启'}</p>
                            </div>
                            <div className="Flex">
                                <div className="Flex SwitchBox">
                                    <p>状态提醒</p>
                                    <Switch onChange={this.changeKugouEffectDiaShow} checked={this.state.kugouEffectDiaShow} className="Normal"  color="primary" />
                                </div>
                                <div className="YunBtn Large YellowColor" onClick={this.showKugouEffectHandleDia}>{this.state.kugouEffectEnable ? '关闭音效' : '开启音效'}</div>
                            </div>
                        </YunSection>
                    )
                }
                {/* 升降调插件安装 */}
                <YunSection className="SettingBox Large" width="200" height="130">
                    <div className="Flex">
                        <div className="Label">升降调插件</div>
                        <div onClick={() => this.clickToPluginDir("kugou")} className="YunBtn Large MainColor">X86 插件</div>
                    </div>
                    <div className="Flex">
                        <div><span className="KugouColor">酷狗</span>播放器</div>
                        <div className="Flex">
                            <div onClick={() => this.handleShowAddDia("kugou")} className="YunBtn Confirm Small RightGap">添 加</div>
                            <div onClick={() => this.handleShowRemoveDia("kugou")} className="YunBtn Small">移 除</div>
                        </div>
                    </div>
                    <div className="Flex">
                        <div><span className="KuwoColor">酷我</span>播放器</div>
                        <div className="Flex">
                            <div onClick={() => this.handleShowAddDia("kuwo")} className="YunBtn Confirm Small RightGap">添 加</div>
                            <div onClick={() => this.handleShowRemoveDia("kuwo")} className="YunBtn Small">移 除</div>
                        </div>
                    </div>
                    <div className="Flex">
                        <div><span className="QqColor">QQ音乐</span>播放器</div>
                        <div className="Flex">
                            <div onClick={() => this.handleShowAddDia("qq")} className="YunBtn Confirm Small RightGap">添 加</div>
                            <div onClick={() => this.handleShowRemoveDia("qq")} className="YunBtn Small">移 除</div>
                        </div>
                    </div>
                </YunSection>
                <YunSection className="SettingBox Between" width="200" height="131">
                    <div className="Label">
                        伴奏升降调模式
                    </div>
                    <div className={sharpFlatModel === "reset" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetSharpFlatModel("reset")} className="YunBtn Large">自动重置</div>
                        <div className="CursorDefault">切歌升降调归零</div>
                    </div>
                    <div className={sharpFlatModel === "renew" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetSharpFlatModel("renew")} className="YunBtn Large">自动恢复</div>
                        <div className="CursorDefault">
                            <p className="">切歌升降调恢复</p>
                            <p className="MainColor">(之前您的设置值)</p>
                        </div>
                    </div>
                    <div className={sharpFlatModel === "lock" ? "ModelSelect Active" : "ModelSelect"}>
                        <div onClick={() => this.clickSetSharpFlatModel("lock")} className="YunBtn Large">锁定状态</div>
                        <div className="CursorDefault">保持升降调不变</div>
                    </div>
                </YunSection>
                <Dialog open={this.state.addDia} onClose={this.handleClose} className={diaClassNameStr}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        添加升降调插件将会关闭你的{this.state.diaText}，是否继续？
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleClose}>取消</div>
                        <div className="YunBtn Small" onClick={this.handleInstallPlugin}>确认</div>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.removeDia} onClose={this.handleClose} className={diaClassNameStr}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        移除升降调插件将会关闭你的{this.state.diaText}，是否继续？
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleClose}>取消</div>
                        <div className="YunBtn Small" onClick={this.handleUnInstallPlugin}>确认</div>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.kugouEffectHandleDia} onClose={this.handleClose} className={diaClassNameStr}>
                    <DialogTitle>
                        提示
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.kugouEffectEnable ?
                            "关闭酷狗内部音效将会关闭你的酷狗播放器，是否继续？"
                            :
                            "开启酷狗内部音效将会关闭你的酷狗播放器，并且升降调功能可能不生效，是否继续？"
                        }
                    </DialogContent>
                    <DialogActions>
                        <div className="YunBtn Small" onClick={this.handleClose}>取消</div>
                        <div className="YunBtn Small" onClick={this.changeKugouEffectEnable}>确认</div>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default SharpFlat;
